import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Environmental from './pages/Environmental';
import Social from './pages/Social';
import Governance from './pages/Governance';
import Analytics from './pages/Analytics';
import Reports from './pages/Reports';
import GoalTracker from './pages/GoalTracker';
import SupplyChain from './pages/SupplyChain';
import StakeholderEngagement from './pages/StakeholderEngagement';
import CarbonAccounting from './pages/CarbonAccounting';
import RiskAssessment from './pages/RiskAssessment';
import SustainableFinance from './pages/SustainableFinance';
import Settings from './pages/Settings';

function App() {
  const [isDemoActive, setIsDemoActive] = useState(false);

  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<Dashboard isDemoActive={isDemoActive} setIsDemoActive={setIsDemoActive} />} />
          <Route path="/environmental" element={<Environmental />} />
          <Route path="/social" element={<Social />} />
          <Route path="/governance" element={<Governance />} />
          <Route path="/analytics" element={<Analytics />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/goals" element={<GoalTracker />} />
          <Route path="/supply-chain" element={<SupplyChain />} />
          <Route path="/stakeholders" element={<StakeholderEngagement />} />
          <Route path="/carbon-accounting" element={<CarbonAccounting />} />
          <Route path="/risk-assessment" element={<RiskAssessment />} />
          <Route path="/sustainable-finance" element={<SustainableFinance />} />
          <Route path="/settings" element={<Settings />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;